define(function(require,exports,module) {
    var tpl =   '<% if(indexTopSearchKeyWords) { %>' +
                    '<% for(i=0; i<indexTopSearchKeyWords.length; i++) { %>' +
                        '<a href="<%=indexTopSearchKeyWords[i].linkText%>" target="_blank" class="style-red"><%=indexTopSearchKeyWords[i].text%></a>' +
                    '<% } %>' +
                '<% } %>';
    exports.tpl = tpl;
});


// WEBPACK FOOTER //
// ./src/js/template/hotKey.js